<template lang="pug">
  include /mixins
  +b.review--answer
    +e.top
      +b.review-author
        +e.img-wrap
          +e.img.IMG(
            :src='child.props.avatar || "/static/img/rebranding/non.png"'
          )
        +e.name.P {{ child.props.name }}
      +e.rate
        +e.text.P {{ child.props.created_at }}
    +e.content
      pre {{child.props.original_lang}} {{lang}}
      template(
        v-if='child.props.original_lang && child.props.original_lang !== lang'
      )
        +e.body--tiny(
        )
          p() {{ showTrans ? child.props.comment : child.props.translation_comment }}
        +b.ds-caption--size_xs.P(v-if='!showTrans') {{_('Переведено автоматически')}}
        +b.ds-caption--size_xs.--color_accent.pointer.A(
          @click='showTrans = !showTrans'
        ) {{ showTrans ? _('Показать перевод') : _('Показать оригинал')  }}
      +e.body(v-else)
        p {{ child.props.comment }}
</template>

<script>
export default {
  name: 'ReviewChildDetail',
  props: {
    child: {
      type: Object,
      default: () => {},
    },
    replier: {
      type: Function,
    },
    showMedia: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      lang: window.language,
      showTrans: false,
      transes: {},
    };
  },
  methods: {
    photoMap(arr) {
      const [first] = arr.map(el => el.props.img)
      return first
    },
  },
}
</script>
